import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class RemindersService {

  public mtds: Methods = new Methods();

  public url: string;
  public token;
  public headers;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/reminder/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
  }

  getUser(id: string): Observable<any> {
    return this.petition(GLOBAL.url + '/user/detail/' + id);
  }

  save(json: any): Observable<any> {
    console.log(json);
    if (json.id === null) {
      return this.create(json);
    } else {
      return this.edit(json.id, json);
    }
  }

  create(json: any): Observable<any> {
    return this.petition(this.url + 'create', json);
  }

  edit(id: string, json: any): Observable<any> {
    return this.petition(this.url + 'edit/' + id, json);
  }

  delete(id: string): Observable<any> {
    return this.petition(this.url + 'remove/' + id);
  }

  showOne(id: string): Observable<any> {
    const params = `authorization=${this.token}`;
    const page = 1;

    return this._http.post<any>(`${this.url}detail/${id}?page=${page}`, params, { headers: this.headers })
      .pipe(map(res => res));
  }

  showAll(page = 1, perPage = 10, busqueda = null, type = 'USER', all = 0, allreps = 0, order = 'DESC', orderby = null): Observable<any> {
    let json = null;
    if (busqueda !== null && busqueda !== '') {
      json = {
        busqueda: busqueda,
      };
    }

    let url = `${this.url}listbytype/${type}?page=${page}&perpage=${perPage}&all=${all}&allreps=${allreps}`;

    if (orderby) {
      url = `${url}&order=${order.toUpperCase()}&orderby=${orderby}`;
    }

    return this.petition(url, json);
  }

  private petition(url: string, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params, response;
    params = `authorization=${this.token}`;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = `${params}&json=${json}`;
    }

    if (type != null) {
      params = `${params}&type=${type}`;
    }

    response = this._http.post<any>(url, params, { headers: this.headers })
      .pipe(map(res => res));

    response.subscribe(
      (res) => {},
      (error) => {
        if (error.status === 404) {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }
      }
    );

    return response;
  }
}
